import $ from "jquery";
import _ from "lodash";
 
export default function columns() {
   const $html = $("html");
   const $scroller = $("html, body");

   $(function() {
      if($('.body_column').length) {
         $.each($('.body_column'), function(){
            let _this = $(this);
            
            if(_this.html() == '') {
               _this.addClass('-empty');
            }
         });
      }
   });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/columns.js